module.exports = __webpack_public_path__ + "static/HotCutter-11e53138f4c66667b3326aa5504853a8.jpg";